import i18n from "@/i18n";
import { ResourceAccess, ResourceType } from "@/services/security/types";

export const userResourceAclFields = [
    {
        key: "name",
        label: i18n.t("common.name"),
        sortable: true,
        sortDirection: "desc"
    },
    {
        key: "type",
        label: i18n.t("common.type"),
        sortable: true,
        sortDirection: "desc",
        formatter: formatType
    },
    {
        key: "resourceAccesses",
        label: i18n.t("common.access"),
        sortable: true,
        sortDirection: "desc"
    },
    {
        key: "actions",
        label: ""
    }
];

// helper methods
function formatType(type: ResourceType) {
    return i18n.t(`common.${toCamelCase(ResourceType[type])}`);
}

function toCamelCase(value: string) {
    return value.length > 5 ? value.replace(/(?:^\w|[A-Z]|\b\w)/g, function (word, index) {
        return index === 0 ? word.toLowerCase() : word.toUpperCase();
    }).replace(/\s+/g, "") : value.toLowerCase();
}
